"use client";
import {
  useComboboxScopedContext
} from "../__chunks/DWZ7E5TJ.js";
import {
  useCompositeSeparator
} from "../__chunks/WEEEI3KU.js";
import "../__chunks/LOI6GHIP.js";
import "../__chunks/WENSINUV.js";
import "../__chunks/FMYQNSCK.js";
import "../__chunks/54MGSIOI.js";
import "../__chunks/DU4D3UCJ.js";
import "../__chunks/RGUP62TM.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/HKOOKEDE.js";
import "../__chunks/Z32BISHQ.js";
import "../__chunks/SK3NAZA3.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/3YLGPPWQ.js";

// src/combobox/combobox-separator.tsx
import { invariant } from "@ariakit/core/utils/misc";
var TagName = "hr";
var useComboboxSeparator = createHook(function useComboboxSeparator2(_a) {
  var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
  const context = useComboboxScopedContext();
  store = store || context;
  invariant(
    store,
    process.env.NODE_ENV !== "production" && "ComboboxSeparator must be wrapped in a ComboboxList or ComboboxPopover component."
  );
  props = useCompositeSeparator(__spreadValues({ store }, props));
  return props;
});
var ComboboxSeparator = forwardRef(function ComboboxSeparator2(props) {
  const htmlProps = useComboboxSeparator(props);
  return createElement(TagName, htmlProps);
});
export {
  ComboboxSeparator,
  useComboboxSeparator
};
